import { RESET_REGISTER_STATE } from './actionTypes';

export default (message) => ({
  type: RESET_REGISTER_STATE,
  payload: {
  }
});